import { SportType } from '../../interface/odds';

export enum MessageType {
  PUBLIC = 0,
  PRIVATE = 1,
  SYSTEM = 2,
}

export enum MessageStyle {
  NORMAL = 0,
  HIGHLIGHT = 1,
}

export interface NotificationDetailResponse {
  Content: string;
  CreatedTime: number;
  MessageType: MessageType;
  SportType: SportType;
}

export interface NotificationCountResponse {
  NewsHistory: number;
  PrivateMessage: number;
}
